module.exports = __webpack_public_path__ + "img/arrow-white.72970d73.svg";